/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'
import {connect} from 'react-redux'

import {signUp} from '../../actions'

import * as Yup from 'yup'
import {withFormik, Form, Field} from 'formik'

import {Errors, FormikTextField} from '../generics'

import Button from '@mui/material/Button'
import EmailIcon from '@mui/icons-material/Email'
import LockIcon from '@mui/icons-material/Lock'



const styles = {
  root: css`
    width: 100%;
  `,
  errorsContainer: css`
    min-height: 20px;
    margin-bottom: 10px;
  `,
  signInForm: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 25px;

    @media (max-width: 600px) {
      gap: 18px;
    }
  `,
  icon: css`
    margin-right: 10px;
  `,
  button: css`
    min-height: 44px;
    max-height: 44px;
    overflow: hidden;
  `
}



const SignUpForm = ({
  errors,
  values,
  handleBlur,
  isSubmitting, 
  setFieldValue,
}) => {  
  return (
    <div css={styles.root}>
      <div css={styles.errorsContainer}>
        <Errors errors={errors.unmatched} />
      </div>

      <Form css={styles.signInForm}>
        <Field
          required
          fullWidth
          type='email' 
          name='email'
          spellCheck='false'
          placeholder='Email'
          variant='filled'
          autoComplete='email'
          component={FormikTextField}
          startAdornment={<EmailIcon css={styles.icon} fontSize='small' />}
        />

        <Field 
          required
          fullWidth
          variant='filled'
          type='password' 
          name='password'
          autoComplete='new-password'
          placeholder='Password' 
          component={FormikTextField}
          startAdornment={<LockIcon css={styles.icon} fontSize='small' />}
        />

        <Field
          required
          fullWidth
          type='password' 
          name='password_confirmation'
          autoComplete='new-password'
          placeholder='Password Confirmation'
          variant='filled' 
          component={FormikTextField}
          startAdornment={<LockIcon css={styles.icon} fontSize='small' />}
        />

        <Button
          fullWidth
          type='submit'
          color='primary'
          css={styles.button}
          variant='contained' 
          disabled={isSubmitting}
        >
          Sign Up
        </Button>
      </Form>
    </div>
  )  
}


const EnhancedSignUpForm = withFormik({
  enableReinitialize: true,

  mapPropsToValues: props => { 
    const {email} = props

    return {
      email: email,
      password: '',
      password_confirmation: ''
    }
  },

  validationSchema: Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().min(6).required(),
    confirmation: Yup.string().oneOf([Yup.ref('password'), null], 'passwords must match')
  }),

  handleSubmit: (values, formikBag) => {
    const {
      type, 
      token,
      signUp, 
      method,
      utmSource,
      utmMedium,
      utmCampaign,
      setIsLoading,
      onSuccess
    } = formikBag.props


    const user = {
      ...values, 
      token, 
      method,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign
    }


    const hasNextStep = (type !== 'user')
    const {setSubmitting, setErrors} = formikBag

    setIsLoading(true)

    signUp(user, hasNextStep).then(response => {
      setIsLoading(false)
      setSubmitting(false)
      onSuccess()
    })
    .catch(error => {
      setIsLoading(false)
      setSubmitting(false)
      setErrors(error.apiFormErrors(values))
    })
  }
})(SignUpForm)




export default connect(null, {signUp})(EnhancedSignUpForm)






